import { useEffect, useState } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { getByClanakIdAndDateRange } from "../../services/statistikaClanka.service";
import { format, subDays, parseISO } from "date-fns";
import "./ChartClanak.css";

const ChartClanak = ({ clanakId }) => {
  const [data, setData] = useState([]);
  const colors = [
    "#AED9E0",
    "#B5EAD7",
    "#E6E6FA",
    "#D3D3D3",
    "#FFD1DC",
    "#FF9AA2",
    "#FFB7B2",
  ];

  useEffect(() => {
    if (!clanakId) return;

    const fetchData = async () => {
      try {
        const endDate = new Date();
        const startDate = subDays(endDate, 6);
        const { data: posjete } = await getByClanakIdAndDateRange(
          clanakId,
          format(startDate, "yyyy-MM-dd"),
          format(endDate, "yyyy-MM-dd")
        );
        const last7Days = Array.from({ length: 7 }, (_, i) => {
          const date = format(subDays(endDate, 6 - i), "dd.MM.yyyy.");
          return {
            date,
            posjete: 0,
            fill: colors[i % colors.length],
          };
        });

        posjete.forEach((posjeta) => {
          const rawDate = posjeta.vremenskaOznaka || posjeta.vremenska_oznaka;
          if (!rawDate) return;

          const visitDate = parseISO(rawDate);
          if (isNaN(visitDate)) return;

          const formattedDate = format(visitDate, "dd.MM.yyyy.");
          const found = last7Days.find((item) => item.date === formattedDate);
          if (found) found.posjete += 1;
        });

        setData(last7Days);
      } catch (error) {
      }
    };

    fetchData();
  }, [clanakId]);

  return (
    <div className="chart-clanak-container">
      <h2 className="chart-clanak-h2">Posjećenost članka u zadnjih 7 dana</h2>
      <ResponsiveContainer width="100%" height={400}>
        <BarChart
          data={data}
          margin={{ top: 30, right: 30, left: 20, bottom: 60 }}
        >
          <XAxis
            dataKey="date"
            angle={-30}
            textAnchor="end"
            height={60}
            interval={0}
          />
          <YAxis />
          <Tooltip />
          <Legend />
          <Bar dataKey="posjete" name="Broj posjeta">
            {data.map((entry, index) => (
              <cell key={`cell-${index}`} fill={entry.fill} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default ChartClanak;
